import { Currencies, WalletTypes } from '@constants/enums';
import { Dialog, DialogContent, DialogTitle } from '@efexteam/components';
import { Alert, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CurrencySelector from './components/CurrencySelector/CurrencySelector';
import SnackBarComponent from './components/CurrencySelector/SnackBarComponent';
import DownloadButton from './components/DownloadButton/DownloadButton';
import Instructions from './components/Instructions/Instructions';
import useNewAddFundsModal from './hooks/useNewAddFundsModal';
import AddFundsModalStyles from './NewAddFundsModal.style';

interface AddFundsModalProps {
  open: boolean;
  initCurrency?: Currencies;
  initWalletType?: WalletTypes;
  onClose: () => void;
}

const NewAddFundsModal = ({
  open,
  initCurrency,
  initWalletType = WalletTypes.GLOBAL_ACCOUNT,
  onClose,
}: AddFundsModalProps) => {
  const { t } = useTranslation();

  const {
    business,
    wallet,
    isGlobalAccount,
    selectedCurrency,
    isCopied,
    values,
    loading,
    instructions,
    currency,
    handleOnCurrencyChange,
    copyToClipboard,
  } = useNewAddFundsModal({
    initCurrency,
    initWalletType,
  });

  if (!business?.enterpriseId) return null;

  return (
    <Dialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
      <DialogTitle showCloseButton onClick={onClose}>
        {t('afnTitle')}
      </DialogTitle>

      <DialogContent className={AddFundsModalStyles.wrapper}>
        <CurrencySelector
          defaultCurrency={selectedCurrency}
          walletType={wallet?.wallet.wallet_type}
          onCurrencyChange={handleOnCurrencyChange}
        />
        {!isGlobalAccount && (
          <Box className={AddFundsModalStyles.alertContainer}>
            <Alert severity="warning" className={AddFundsModalStyles.alert}>
              {t('afnWalletAlert')}
            </Alert>
          </Box>
        )}
        <Instructions
          instructions={instructions}
          loading={loading}
          currency={currency}
          onCopy={copyToClipboard}
        />
        <DownloadButton
          enterpriseId={business?.enterpriseId}
          currency={currency}
          walletId={wallet?.wallet.id}
        />
      </DialogContent>
      <SnackBarComponent
        isOpen={isCopied}
        message={t('afnCopiedToClipboard', { name: values.name })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
    </Dialog>
  );
};

export default NewAddFundsModal;
